import { FileImageOutlined, HeartFilled, HeartOutlined } from "@ant-design/icons";
import { Button, Col, Row, Space, Statistic } from "antd";
import { format, intervalToDuration, isBefore, isEqual } from "date-fns";
import { useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ItemImage from '../../../assets/images/item_image.png';
import { useCareProductMutation, useUncareProductMutation } from "../../../redux/api/ProductApi";
import { useAppDispatch, useAppSelector } from "../../../redux/Hooks";
import RegisterAuction from "../../auction/online-auction/auction-list/components/RegisterAuction";
import { AuctionResponse, BidderAcceptBidStatus, StartStatus } from "../../auction/types";
import { toggleLoginModal } from "../../login/redux/LoginSlice";
import { ItemCardStatus, preCostTypes } from "../types/types";
import ConfirmModal from "./ConfirmModal";
import PrepayModal from "./PrepayModal";

type CardProps = {
    price?: number,
    description?: string,
    status: ItemCardStatus,
    item: AuctionResponse,
    reloadPage: () => void,
}

interface Countdown {
    day: number,
    hour: number,
    minute: number,
    second: number
}

const defaultCountdown: Countdown = {
    day: 0,
    hour: 0,
    minute: 0,
    second: 0,
}

const ItemListCard = ({ price, description, status, item, reloadPage }: CardProps) => {
    const [countdown, setCountdown] = useState<Countdown>(defaultCountdown);
    const [isFavoriteHovering, setIsFavoriteHovering] = useState(false);
    const navigate = useNavigate()
    const timer: { current: NodeJS.Timeout | null } = useRef(null);
    // const [uncareVisible, setUncareVisible] = useState(false);
    const [registerVisible, setRegisterVisible] = useState(false);
    const [prepayVisible, setPrepayVisible] = useState(false);

    const [uncareProduct] = useUncareProductMutation();
    const [careProduct] = useCareProductMutation();

    const userState = useAppSelector(state => state.login);
    const dispatch = useAppDispatch();

    useEffect(() => {
        let currentDate = new Date()
        let toDate = item.startAuctionDate

        if (item.startStatus === StartStatus.ONGOING) {
            toDate = item.endAuctionDate;
        }
        let endDate = toDate ? new Date(toDate) : currentDate;

        if (isBefore(endDate, currentDate) || isEqual(endDate, currentDate)) {
            setCountdown({
                day: 0,
                hour: 0,
                minute: 0,
                second: 0,
            })
        } else {
            timer.current = setInterval(() => {
                let difference = intervalToDuration({ start: new Date(), end: endDate });
                setCountdown({
                    day: difference.days || 0,
                    hour: difference.hours || 0,
                    minute: difference.minutes || 0,
                    second: difference.seconds || 0,
                })
            }, 1000)
        }

        return () => {
            if (timer.current) {
                clearInterval(timer.current);
            }
        };
    }, [item])


    const onFavoriteMouseOver = () => {
        setIsFavoriteHovering(true);
    }

    const onFavoriteMouseOut = () => {
        setIsFavoriteHovering(false);
    }

    const onFavoriteClick = () => {
        if (!userState.user.userId) {
            dispatch(toggleLoginModal())
        } else if (item.isCare) {
            // uncare
            uncareProduct({ productId: item.productId, statuteId: item.statute.statuteId }).unwrap().then(() => {
                reloadPage();
            })
        } else {
            // care
            careProduct({ productId: item.productId, statuteId: item.statute.statuteId }).unwrap().then(() => {
                reloadPage();
            })
        }
    }

    const toggleRegisterModal = () => {
        if (!userState.user.userId) {
            setRegisterVisible(false);
            dispatch(toggleLoginModal());
        } else if (!userState.incompleteProfile) {
            setRegisterVisible(!registerVisible)
        } else if (userState.incompleteProfile) {
            // Nếu chưa hoàn thành hồ sơ
            navigate("/profile/detail/redirect")
        }
    }

    const togglePrepayModal = () => {
        if (prepayVisible) {
            reloadPage();
        }
        setPrepayVisible(!prepayVisible);
    }

    const cardImageElement = useMemo(() => {
        let cardUrl = process.env.REACT_APP_API_URL + `/files/downloadFile/`;

        if (item.vbAttachmentImages && item.vbAttachmentImages?.length) {
            let avatarIndex = item.vbAttachmentImages.findIndex(img => img.storageType === "avatar");
            cardUrl += avatarIndex !== -1 ? `${item.vbAttachmentImages[avatarIndex].attachmentId}` : `${item.vbAttachmentImages[0].attachmentId}`;
        } else {
            cardUrl = "";
        }

        if (cardUrl) {
            return (
                <img
                    style={{ objectFit: 'cover', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', borderRadius: '15px 0px 0px 15px' }}
                    width='100%'
                    height='200px'
                    alt="example"
                    src={cardUrl}
                    className="item-card-cover" />
            )
        }

        return (
            <div style={{ width: '100%', height: 200, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <FileImageOutlined style={{ fontSize: 50 }} />
            </div>
        )
    }, [item.vbAttachmentImages])

    return (
        <>
            <Link to={`/auction-item/${item.productId}/${item.statute.statuteId}`} reloadDocument style={{ width: '100%' }}>
                <Row
                    className="item-list-card"
                    gutter={30}
                // onClick={(e) => {
                //     e.stopPropagation();
                //     navigate(`/auction-item/${item.productId}/${item.statute.statuteId}`)
                // }}
                >
                    <Col span={5} style={{ marginLeft: -15 }}>
                        {/* <img
                        alt="example"
                        src={ItemImage}
                        className="item-card-cover"
                        style={{ borderRadius: '15px 0px 0px 15px', width: '100%', height: 200, objectFit: 'cover' }} /> */}
                        {cardImageElement}
                    </Col>
                    <Col span={19} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>

                        {status === ItemCardStatus.PAUSE ?
                            <div className="item-card-status-list-top item-card-status-gray">
                                ĐÃ TẠM DỪNG ĐẤU GIÁ
                            </div> : <></>}

                        {status === ItemCardStatus.FAILED || (status === ItemCardStatus.SUCCESS &&
                            (!item.bidderAcceptBid?.valueOfBid || item.bidderAcceptBid?.status === BidderAcceptBidStatus.FAILED)) ?
                            <div className="item-card-status-list-top item-card-status-red-bold">
                                ĐẤU GIÁ KHÔNG THÀNH CÔNG
                            </div> : <></>}

                        {status === ItemCardStatus.SUCCESS && item.bidderAcceptBid?.valueOfBid && item.bidderAcceptBid?.status === BidderAcceptBidStatus.SUCCESS ?
                            <div className="item-card-status-list-top item-card-status-green-bold">
                                <div style={{ fontSize: 14, fontWeight: 700 }}>
                                    GIÁ TRÚNG ĐẤU GIÁ
                                    <Statistic
                                        value={item.bidderAcceptBid?.valueOfBid || 0}
                                        groupSeparator="."
                                        decimalSeparator=","
                                        precision={0}
                                        valueStyle={{ fontSize: 16, marginLeft: 5, color: 'white', fontWeight: 700 }}
                                        suffix="VNĐ"
                                        style={{ display: 'inline-block' }}
                                    />
                                </div>
                            </div> : <></>}

                        <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', width: '100%', marginTop: 24 }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <span>Mã tài sản: {item.productCode || "-"}</span>
                            </div>
                            {item.startStatus !== StartStatus.FINISH &&
                                <div className="item-card-action-list">
                                    <Space size={5}>
                                        <div className="item-card-time list-time">{countdown.day}</div>
                                        <div className="item-card-time list-time">{countdown.hour}</div>
                                        <div className="item-card-time list-time">{countdown.minute}</div>
                                        <div className="item-card-time list-time">{countdown.second}</div>
                                    </Space>
                                    <div
                                        style={{ alignSelf: 'center', marginLeft: 20 }}
                                        onMouseEnter={onFavoriteMouseOver}
                                        onMouseLeave={onFavoriteMouseOut}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            onFavoriteClick();
                                        }}>
                                        {isFavoriteHovering || item.isCare ?
                                            <HeartFilled style={{ color: '#E59F17', fontSize: 25 }} /> :
                                            <HeartOutlined style={{ color: 'black', fontSize: 25 }} />
                                        }

                                    </div>
                                </div>
                            }
                        </div>
                        <div className="font-size-18 text-overflow-custom font-bold" style={{ WebkitLineClamp: 2 }}>
                            {item.productName.trim() || "-"}
                        </div>
                        <Row style={{ width: '100%' }} align="middle">
                            <Col span={9} style={{ marginBottom: 30 }}>
                                <span className="font-size-14">
                                    {status !== ItemCardStatus.INPROGRESS ? "Giá khởi điểm" : "Giá hiện tại"}: </span>
                                <span className="font-size-14 font-bold" style={{ marginLeft: 5, color: '#22C55E' }}>
                                    <Statistic
                                        value={item.startPrice}
                                        groupSeparator="."
                                        decimalSeparator=","
                                        precision={0}
                                        style={{ display: 'inline-block' }}
                                        valueStyle={{ fontSize: 14, fontFamily: 'Quicksand', color: '#22C55E' }} /> VNĐ
                                </span>
                            </Col>
                            <Col span={9} style={{ marginBottom: 30 }}>
                                <span className="font-size-14">Thời gian đấu giá: </span>
                                <span className="font-size-14">{item.startAuctionDate ? format(new Date(item.startAuctionDate), "HH:mm dd/MM/yyyy") :
                                    format(new Date(), "HH:mm dd/MM/yyyy")}</span>
                            </Col>
                            {status === ItemCardStatus.NEW ?
                                <>
                                    {item.seller.userId !== userState?.user?.userId && (item.bidderResponseDTO?.registerStatus === -1 || !item.bidderResponseDTO) ?
                                        <Col span={6} style={{ textAlign: 'right' }}>
                                            <Button
                                                style={{ marginBottom: 30, visibility: item.statute.endRegistrationDate && isBefore(new Date(), item.statute.endRegistrationDate) ? 'visible' : 'hidden' }}
                                                className="button-light-yellow font-size-16"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    toggleRegisterModal()
                                                }}
                                            >ĐĂNG KÝ</Button>
                                        </Col> : <Col span={6}></Col>}

                                    {userState?.user?.userId && item.seller.userId !== userState?.user?.userId && item.bidderResponseDTO?.registerStatus === 0 &&
                                        (item.bidderResponseDTO?.preCostStatus === preCostTypes.NOTPAY || item.bidderResponseDTO?.preCostStatus === -1 || item.bidderResponseDTO?.preCostStatus === preCostTypes.FAILED) ?
                                        <Col span={6} style={{ textAlign: 'right' }}>
                                            <Button
                                                style={{ marginBottom: 30, visibility: item.statute.endPrePaymentDate && isBefore(new Date(), item.statute.endPrePaymentDate) ? 'visible' : 'hidden' }}
                                                className="button-light-yellow font-size-16"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    togglePrepayModal()
                                                }}
                                            >NỘP TIỀN</Button>
                                        </Col> : <></>}

                                    {(item.bidderResponseDTO?.registerStatus === 0 || item.bidderResponseDTO?.registerStatus === 1) && item.bidderResponseDTO?.preCostStatus === preCostTypes.WAITING ?
                                        <Col span={6} style={{ height: '100%' }}>
                                            <div className="item-card-status-list item-card-status-yellow">
                                                CHỜ ĐỐI SOÁT
                                            </div>
                                        </Col> : <></>}

                                    {item.bidderResponseDTO?.registerStatus === 1 && item.bidderResponseDTO?.preCostStatus === preCostTypes.DONE ?
                                        <Col span={6} style={{ height: '100%' }}>
                                            <div className="item-card-status-list item-card-status-green">
                                                CHỜ ĐỐI SOÁT
                                            </div>
                                        </Col> : <></>}

                                    {item.bidderResponseDTO?.registerStatus === 2 ?
                                        <Col span={6} style={{ height: '100%' }}>
                                            <div className="item-card-status-list item-card-status-red">
                                                TỪ CHỐI THAM GIA
                                            </div>
                                        </Col> : <></>}

                                    {item.bidderResponseDTO?.registerStatus === 3 ?
                                        <Col span={6} style={{ height: '100%' }}>
                                            <div className="item-card-status-list item-card-status-red">
                                                ĐĂNG KÝ KHÔNG HỢP LỆ
                                            </div>
                                        </Col> : <></>}
                                </>
                                : <Col span={6}></Col>}

                            {status === ItemCardStatus.INPROGRESS ?
                                <Col span={6} style={{ height: '100%' }}>
                                    <div className="item-card-status-list item-card-status-blue">
                                        ĐANG DIỄN RA
                                    </div>
                                </Col> : <Col span={6}></Col>}
                        </Row>
                    </Col>
                </Row >
            </Link>
            {
                registerVisible ? <RegisterAuction
                    visible={registerVisible}
                    itemId={item.productId}
                    statuteId={item.statute.statuteId}
                    toggleModal={toggleRegisterModal}
                    onSuccess={reloadPage}
                /> : <></>}

            {
                prepayVisible ? <PrepayModal
                    visible={prepayVisible}
                    productId={item.productId}
                    productName={item.productName}
                    statuteId={item.statute.statuteId}
                    preCost={item.preCost + (item.anotherCost || 0)}
                    toggleModal={togglePrepayModal}
                    onSuccess={reloadPage}
                /> : <></>
            }
        </>
    )
}

export default ItemListCard;